import { render, staticRenderFns } from "./public-editions.vue?vue&type=template&id=6eb178c3&scoped=true&"
import script from "./public-editions.vue?vue&type=script&lang=ts&"
export * from "./public-editions.vue?vue&type=script&lang=ts&"
import style0 from "./public-editions.vue?vue&type=style&index=0&id=6eb178c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb178c3",
  null
  
)

export default component.exports